import React from 'react';
import styled from 'styled-components';

// 스타일링된 컴포넌트를 생성합니다.
const TutorialArea = styled.div`
  #clip-01 {
    --x: 1780px;
    --y: 90px;
    --width: 118px;
    --height: 59px;

    top: 0;
    left: 0;
    width: 1920px;
    height: 1080px;
  }

  #text-01 {
    top: 190px;
    left: 1283px;
  }

  #line-01 {
    top: 120px;
    left: 1722px;
  }
`;

const IssueTrend02 = () => {
  return (
    <>
      <TutorialArea className='tutorial-area'>
        <div id="clip-01" className="clip-box">
          <div id="clip-01-hole" className="hole" />
          <div id="clip-01-border" className="border" />
        </div>

        <div className="text-box">
          <div id="text-01" className="text">You can select indicators which you want to see</div>
        </div>

        <div className="line-box">
          <div id="line-01" className="line">
            <img src="/common/images/iss/tutorial/t_6123_line_01.png" alt='Line' />
          </div>
        </div>
      </TutorialArea>
    </>
  );
};

export default IssueTrend02;